window.cpap.onDocumentReady(() => {
  // 🚨 This is only for user-blocking logic. Nothing that is user-visible or background should be included here!
  // @see https://developer.mozilla.org/en-US/docs/Web/API/Prioritized_Task_Scheduling_API#task_priorities
  window.scheduler.postTask(
    () => {
      const factCheckBadgeNode = document.querySelector(
        '.cpap__blog-article-hero-banner__fact-check'
      );

      let factCheckModal;

      factCheckBadgeNode.addEventListener('click', () => {
        window.cpap.dynamicallyLoadScript(window.cpap.cdnSources.bootstrapModalJs, {
          onload: () => {
            if (!factCheckModal) {
              factCheckModal = new bootstrap.Modal(
                document.querySelector('.cpap__fact-check-modal')
              );
            }

            factCheckModal.show();
          },
        });
      });

      document
        .querySelector('.cpap__fact-check-modal__close-button')
        ?.addEventListener('click', () => {
          factCheckModal?.hide();
        });
    },
    { priority: 'user-blocking' }
  );
});
